import { createStore } from "vuex";
import { auth } from "./auth.module";
import { theme } from "./theme.module";
import { swithUser } from "./switch-user.module";

import { subscriberDirectory } from "./subscriber/subscriber.module";
const store = createStore({
    modules: {
        auth,
        theme,
        swithUser,
        subscriberDirectory
    },
});

export default store;